import { Reservation, Resource, ResourceCategory, ResourceCategoryAssignment } from '@mews-commander/data-access';
import { compactArray } from '@mews/fp';
import { UnicodeEntity } from '@mews/enums';

export const getResourceName = (
    reservation: Reservation,
    resources: Record<string, Resource>,
    resourceCategories: Record<string, ResourceCategory>,
    resourceCategoryAssignments: Record<string, ResourceCategoryAssignment>
) => {
    const categoryId = reservation.assignedResourceId
        ? resourceCategoryAssignments[reservation.assignedResourceId]?.categoryId
        : reservation.requestedCategoryId;
    const resourceName = reservation.assignedResourceId ? resources[reservation.assignedResourceId]?.name : undefined;
    const categoryName = categoryId ? resourceCategories[categoryId]?.shortName : undefined;

    return compactArray([categoryName, resourceName]).join(UnicodeEntity.Space);
};
